(() => {
  'use strict';
  document.documentElement.classList.add('bs-js');
  const base = window.Shopify?.routes?.root || '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(value / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const request = async (url, body) => {
    const response = await fetch(base + url, {method:body ? 'POST' : 'GET',headers:body ? {'Content-Type':'application/json'} : {},body:body ? JSON.stringify(body) : undefined});
    const data = await response.json();
    if (!response.ok) throw Error(data.description || data.message || 'No se ha podido completar la acción. Inténtalo de nuevo.');
    return data;
  };
  const arrowUpRight = "<svg class=\"bs-icon bs-icon--arrow-up-right\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.65\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M7 17 17 7M7 7h10v10\"/></svg>";
  let cartBusy = false;
  let returnFocus = null;

  function cartRender(cart) {
    document.querySelectorAll('[data-bs-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.getElementById('bs-cart-items');
    if (!items) return;
    items.innerHTML = cart.items.length ? cart.items.map(item => `<article class="bs-cart-item"><a href="${esc(item.url)}"><img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="86" height="100"></a><div><a href="${esc(item.url)}"><h3>${esc(item.product_title)}</h3></a><p>Talla ${esc(item.variant_title)}</p>${item.properties?.Pack ? `<small class="bs-cart-pack">${esc(item.properties.Pack)}</small>` : ''}<div class="bs-cart-item-controls"><div class="bs-cart-qty"><button type="button" data-bs-cart-key="${esc(item.key)}" data-bs-quantity="${item.quantity-1}" aria-label="${item.quantity === 1 ? 'Eliminar' : 'Restar una'} ${esc(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-bs-cart-key="${esc(item.key)}" data-bs-quantity="${item.quantity+1}" aria-label="Añadir una ${esc(item.product_title)}">+</button></div><strong>${money(item.final_line_price)}</strong></div></div></article>`).join('') : `<p class="bs-cart-empty">Tu carrito está vacío.<br><a href="${base}#catalogo" data-bs-close>Explorar camisetas ${arrowUpRight}</a></p>`;
    document.getElementById('bs-cart-total').textContent = money(cart.total_price);
    const bottom = document.querySelector('.bs-cart-bottom');
    bottom.hidden = !cart.items.length;
    let savings = document.getElementById('bs-cart-savings');
    if (!savings) {savings = document.createElement('div');savings.id = 'bs-cart-savings';savings.className = 'bs-cart-savings';bottom.prepend(savings);}
    savings.hidden = !cart.total_discount;
    savings.innerHTML = `<span>Descuento aplicado</span><strong>−${money(cart.total_discount)}</strong>`;
  }

  async function cartOpen() {
    const dialog = document.getElementById('bs-cart');
    if (!dialog) {location.href = base + 'cart';return;}
    cartRender(await request('cart.js'));
    if (!dialog.open) {returnFocus = document.activeElement;dialog.showModal();document.body.style.overflow = 'hidden';}
  }

  function closeCart() {const dialog = document.getElementById('bs-cart');if (dialog?.open) dialog.close();}

  function initProduct(el) {
    if (el.dataset.bsReady) return;
    el.dataset.bsReady = 'true';
    const variants = JSON.parse(el.querySelector('[data-bs-variants]').textContent);
    const config = JSON.parse(el.querySelector('[data-bs-product-config]').textContent);
    const form = el.querySelector('.bs-product-form');
    const select = el.querySelector('#bs-variant');
    const stock = el.querySelector('[data-bs-stock]');
    const add = el.querySelector('.bs-add');
    const sticky = el.querySelector('.bs-sticky-buy');
    const stickyAdd = el.querySelector('[data-bs-sticky-add]');
    const singleTitle = sticky.querySelector('small').textContent;
    const pack = el.querySelector('[data-bs-pack]');
    const packConfig = pack ? JSON.parse(el.querySelector('[data-bs-pack-config]').textContent) : null;
    const catalog = pack ? JSON.parse(el.querySelector('[data-bs-pack-products]').textContent) : [];
    let adding = false;
    const selectedVariant = () => variants.find(v => String(v.id) === select.value);
    const isPack = () => pack && pack.querySelector('input[value="double"]').checked;
    const packRows = pack ? [...pack.querySelectorAll('[data-bs-pack-item]')] : [];
    const selections = () => packRows.map(row => {
      const p = catalog.find(p => String(p.id) === row.querySelector('[data-bs-pack-product]').value);
      return p?.variants.find(v => String(v.id) === row.querySelector('[data-bs-pack-variant]').value);
    });
    const completePack = () => {
      const chosen = selections();
      return chosen.length === 2 && chosen.every(v => v && v.available && v.price === packConfig.unitPrice);
    };

    function sync() {
      const v = selectedVariant();
      if (!v) return;
      el.querySelectorAll('[data-bs-variant]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bsVariant === select.value)));
      el.querySelector('[data-bs-price]').innerHTML = v.formatted;
      if (v.available && v.quantity > 0 && v.quantity <= config.threshold) {
        stock.replaceChildren(Object.assign(document.createElement('span'), {className:'bs-dot'}), document.createTextNode(stock.dataset.template.replace('[cantidad]',v.quantity).replace('[talla]',v.title)));
      } else stock.textContent = v.available ? config.available : stock.dataset.empty;
      const double = isPack();
      const ready = double ? completePack() : v.available;
      el.classList.toggle('is-pack-mode', Boolean(double));
      if (pack) {
        pack.querySelectorAll('[data-bs-pack-option]').forEach(option => option.classList.toggle('is-selected', option.dataset.bsPackOption === (double ? 'double' : 'single')));
        pack.querySelector('[data-bs-pack-builder]').hidden = !double;
        pack.querySelector('[data-bs-single-price]').innerHTML = v.formatted;
        const status = pack.querySelector('[data-bs-pack-status]');
        status.textContent = ready ? packConfig.ready : packConfig.incomplete;
        status.classList.toggle('is-ready', ready);
      }
      add.disabled = adding || !ready;
      add.toggleAttribute('aria-busy', adding);
      const text = adding ? (packConfig?.loading || 'Añadiendo…') : double ? (ready ? `${packConfig.add} · ${money(packConfig.price)}` : packConfig.incomplete) : v.available ? add.dataset.addText : add.dataset.soldText;
      el.querySelector('[data-bs-add-label]').textContent = text;
      sticky.querySelector('small').textContent = double ? packConfig.name : singleTitle;
      el.querySelector('[data-bs-sticky-price]').innerHTML = double ? money(packConfig.price) : v.formatted;
      stickyAdd.disabled = adding || (!double && !v.available);
      stickyAdd.textContent = double ? (ready ? packConfig.add : packConfig.configure) : v.available ? add.dataset.addText : add.dataset.soldText;
    }

    function changeVariant() {
      sync();
      const url = new URL(location.href);
      url.searchParams.set('variant',select.value);
      history.replaceState(null,'',url);
    }
    select.addEventListener('change',changeVariant);
    el.querySelectorAll('[data-bs-variant]').forEach(btn => btn.addEventListener('click',() => {select.value = btn.dataset.bsVariant;changeVariant();}));
    el.querySelectorAll('[data-bs-image]').forEach(btn => btn.addEventListener('click',() => {
      const image = el.querySelector('#bs-main-image');
      image.src = btn.dataset.bsImage;
      image.removeAttribute('srcset');
      image.alt = btn.dataset.bsAlt || image.alt;
      el.querySelector('[data-bs-gallery-caption]').textContent = btn.dataset.bsCaption;
      el.querySelectorAll('[data-bs-image]').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
    }));
    const photoDialog = el.querySelector('[data-bs-photo-dialog]');
    el.querySelector('[data-bs-zoom]')?.addEventListener('click',() => {
      const main = el.querySelector('#bs-main-image'), large = photoDialog.querySelector('img');
      large.src = main.src;large.alt = main.alt;photoDialog.showModal();
    });
    photoDialog?.querySelector('[data-bs-photo-close]').addEventListener('click',() => photoDialog.close());
    photoDialog?.addEventListener('click',e => {if (e.target === photoDialog) photoDialog.close();});

    const sizeDialog = el.querySelector('[data-bs-size-dialog]');
    const sizeLink = el.querySelector('[data-bs-size-open]');
    if (sizeDialog && sizeLink) {
      let previousOverflow = '';
      sizeLink.addEventListener('click',event => {
        event.preventDefault();
        if (sizeDialog.open) return;
        previousOverflow = document.body.style.overflow;
        sizeDialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      sizeDialog.querySelector('[data-bs-size-close]').addEventListener('click',() => sizeDialog.close());
      sizeDialog.addEventListener('click',event => {if (event.target === sizeDialog) sizeDialog.close();});
      sizeDialog.addEventListener('close',() => {
        document.body.style.overflow = previousOverflow;
        sizeLink.focus({preventScroll:true});
      });
    }

    if (pack) {
      const eligible = p => p.variants.some(v => v.price === packConfig.unitPrice && v.available);
      if (!catalog.some(eligible)) pack.hidden = true;
      pack.querySelectorAll('input[name="bs_purchase_mode"]').forEach(radio => radio.addEventListener('change',sync));
      packRows.forEach(row => {
        const productSelect = row.querySelector('[data-bs-pack-product]');
        const variantSelect = row.querySelector('[data-bs-pack-variant]');
        catalog.forEach(p => {const option = new Option(p.title.replace(/^Camiseta\s+/i,''),String(p.id));option.disabled = !eligible(p);productSelect.add(option);});
        productSelect.addEventListener('change',() => {
          const p = catalog.find(p => String(p.id) === productSelect.value);
          variantSelect.replaceChildren(new Option(packConfig.sizePlaceholder,''));
          variantSelect.disabled = !p;
          row.querySelector('[data-bs-pack-size-field]').hidden = !p;
          row.classList.toggle('is-selected',Boolean(p));
          const image = row.querySelector('[data-bs-pack-thumb]');
          image.hidden = !p;
          if (p) {
            image.src = p.image;image.alt = p.title;
            p.variants.forEach(v => {const option = new Option(v.title + (!v.available ? ` · ${packConfig.sold}` : ''), String(v.id));option.disabled = !v.available || v.price !== packConfig.unitPrice;variantSelect.add(option);});
          }
          sync();
        });
        variantSelect.addEventListener('change',sync);
      });
    }

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (cartBusy || adding || add.disabled) return;
      cartBusy = true;adding = true;
      const error = el.querySelector('.bs-form-error');error.hidden = true;
      const double = isPack();
      sync();
      try {
        let items;
        if (double) {
          if (!completePack()) throw Error(packConfig.incomplete);
          const chosen = selections();
          const grouped = new Map();
          chosen.forEach(v => {const old = grouped.get(v.id);grouped.set(v.id,{variant:v,quantity:(old?.quantity || 0)+1});});
          const cart = await request('cart.js');
          for (const entry of grouped.values()) {
            const already = cart.items.filter(i => i.variant_id === entry.variant.id).reduce((n,i) => n + i.quantity,0);
            if (entry.variant.quantity >= 0 && already + entry.quantity > entry.variant.quantity) throw Error(packConfig.stockError);
          }
          const group = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          items = [...grouped.values()].map(entry => ({id:entry.variant.id,quantity:entry.quantity,properties:{Pack:packConfig.name,_bs_pack_id:group}}));
        } else items = [{id:Number(select.value),quantity:1}];
        await request('cart/add.js',{items});
        await cartOpen();
      } catch (e) {error.textContent = e.message;error.hidden = false;}
      finally {cartBusy = false;adding = false;sync();}
    });
    stickyAdd.addEventListener('click',() => {
      if (isPack() && !completePack()) {
        pack.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        const row = packRows.find(row => !row.querySelector('[data-bs-pack-product]').value || !row.querySelector('[data-bs-pack-variant]').value);
        const control = row?.querySelector(!row.querySelector('[data-bs-pack-product]').value ? '[data-bs-pack-product]' : '[data-bs-pack-variant]');
        control?.focus({preventScroll:true});return;
      }
      form.requestSubmit();
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {sticky.hidden = entries[0].isIntersecting;},{threshold:0}).observe(add);
    sync();
  }

  function initRibbon(el) {
    if (el.dataset.bsReady) return;
    el.dataset.bsReady = 'true';
    const button = el.querySelector('[data-bs-ribbon-pause]');
    if (!button) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = false;
    function sync() {
      el.dataset.paused = String(paused || reduced.matches);
      button.disabled = reduced.matches;
      button.setAttribute('aria-pressed',String(paused));
      button.querySelector('[data-bs-pause-label]').textContent = reduced.matches ? button.dataset.reduced : paused ? button.dataset.play : button.dataset.pause;
      button.querySelector('[aria-hidden]').textContent = paused ? '▷' : 'Ⅱ';
    }
    button.addEventListener('click',() => {paused = !paused;sync();});
    reduced.addEventListener('change',sync);sync();
  }

  function init(root = document) {
    root.querySelectorAll('[data-bs-product]').forEach(initProduct);
    root.querySelectorAll('[data-bs-ribbon]').forEach(initRibbon);
    root.querySelectorAll('#bs-cart:not([data-bs-dialog-ready])').forEach(dialog => {
      dialog.dataset.bsDialogReady = 'true';
      dialog.addEventListener('click',e => {if (e.target === dialog) {const r = dialog.getBoundingClientRect();if (e.clientX < r.left || e.clientX > r.right) closeCart();}});
      dialog.addEventListener('close',() => {document.body.style.overflow = '';returnFocus?.focus();});
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {if (entry.isIntersecting) {entry.target.classList.add('is-in');observer.unobserve(entry.target);}}), {threshold:.08});
      root.querySelectorAll('.bs-detail-photo,.bs-universe,.bs-service-grid article').forEach(el => {if (el.getBoundingClientRect().top > innerHeight * .9) {el.classList.add('bs-soft-reveal');observer.observe(el);}});
    }
  }

  document.addEventListener('click',async event => {
    if (event.target.closest('[data-bs-cart]')) {event.preventDefault();try {await cartOpen();} catch {location.href = base + 'cart';}return;}
    if (event.target.closest('[data-bs-close]')) {closeCart();return;}
    const qty = event.target.closest('[data-bs-cart-key]');
    if (qty) {
      if (cartBusy) return;
      cartBusy = true;qty.disabled = true;
      try {cartRender(await request('cart/change.js',{id:qty.dataset.bsCartKey,quantity:Number(qty.dataset.bsQuantity)}));}
      catch (e) {let error = document.getElementById('bs-cart-error');if (!error) {error = document.createElement('p');error.id = 'bs-cart-error';error.setAttribute('role','alert');error.className = 'bs-form-error';document.getElementById('bs-cart-items').prepend(error);}error.textContent = e.message;}
      finally {cartBusy = false;qty.disabled = false;}
      return;
    }
    const filter = event.target.closest('[data-bs-filter]');
    if (filter) {
      const section = filter.closest('.bs-wrap');
      section.querySelectorAll('[data-bs-filter]').forEach(b => {b.classList.toggle('is-active',b === filter);b.setAttribute('aria-pressed',String(b === filter));});
      section.querySelectorAll('[data-universe]').forEach(card => card.hidden = filter.dataset.bsFilter !== 'all' && card.dataset.universe !== filter.dataset.bsFilter);
      const hint = section.querySelector('[data-bs-swipe-hint]');
      if (hint) hint.hidden = section.querySelectorAll('[data-universe]:not([hidden])').length < 2;
      section.querySelector('.bs-product-grid')?.scrollTo({left:0});
    }
    const universe = event.target.closest('[data-bs-universe]');
    if (universe) {const target = document.querySelector(`[data-bs-filter="${universe.dataset.bsUniverse}"]`);if (target) {event.preventDefault();target.click();target.closest('#catalogo').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});}}
    if (event.target.closest('.bs-mobile-menu a')) document.querySelector('.bs-mobile-menu').open = false;
  });
  document.addEventListener('shopify:section:load',event => init(event.target));
  init();
})();
